import { ImPhone } from "react-icons/im";

interface Props {
  callerNumber: string | null;
}

export function VoiceCallBarRingingView(props: Props) {
  const { callerNumber } = props;

  return (
    <div className="flex items-center gap-2">
      <ImPhone className="mr-2 size-4 animate-pulse text-yellow-700" />
      <span className="text-sm text-white">{callerNumber || "Unknown"}</span>
      <span className="text-sm text-grey-500">Calling...</span>
    </div>
  );
}
